import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataErrorCodeMytelCompate,
  formatDataVmailNatcomCompate,
  getDateChangeTime,
} from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTime from "../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../../Natcom/components/DashboardCompare";
import { Tabs } from 'antd';
import { selectorDataMytelErrorCode } from "../../../../redux/selector";
const { TabPane } = Tabs;

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));

  const { revenue = {} } = useSelector(selectorDataMytelErrorCode);
  const { data = [] } = revenue.result || {};
  // const { result = {} } =
  //   useSelector((state) => state.reducerNatcom?.data) || {};
  // const { data: airtime = [] } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataChart0 = useMemo(() => {
    const convertData = formatDataErrorCodeMytelCompate(
      data,
      startDate,
      endDate,
      true,
      false,
      false,
      false,
    );
    return convertData || [];
  }, [data, startDate, endDate]);
  const dataChart1 = useMemo(() => {
    const convertData = formatDataErrorCodeMytelCompate(
      data,
      startDate,
      endDate,
      false,
      true,
      false,
      false,
    );
    return convertData || [];
  }, [data, startDate, endDate]);
  const dataChart417 = useMemo(() => {
    const convertData = formatDataErrorCodeMytelCompate(
      data,
      startDate,
      endDate,
      false,
      false,
      true,
      false,
    );
    return convertData || [];
  }, [data, startDate, endDate]);
  const dataChartOrther = useMemo(() => {
    const convertData = formatDataErrorCodeMytelCompate(
      data,
      startDate,
      endDate,
      false,
      false,
      false,
      true,
    );
    return convertData || [];
  }, [data, startDate, endDate]);
 
  return (
    <>
          <div
            className="position-relative d-flex justify-right mb-2"
            style={{ justifyContent: "right" }}
          >
            <FilterTime
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
     
      <Tabs defaultActiveKey="1">
        <TabPane tab="Error code 0" key="1">
          <div>
            <DashboardCompare
              dataChart={dataChart0}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Error code -1" key="2">
          <div>
            <DashboardCompare
              dataChart={dataChart1}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Error code 417" key="3">
          <div>
            <DashboardCompare
              dataChart={dataChart417}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Error code orther" key="4">
          <div>
            <DashboardCompare
              dataChart={dataChartOrther}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
}
